const catVarc = [
  // ── RC Passage 1 (id 1-3) ──
  {
    id: 1,
    type: "mcq",
    passageId: "rc1",
    passage: `The rise of gig work has forced economists to reconsider what "employment" even means. For most of the twentieth century, a job implied a single employer, a fixed schedule, and a bundle of benefits tied to that employer. Gig platforms unbundle all three: a worker may log hours for several apps in a single day, set their own schedule, and receive no benefits at all. Proponents argue this flexibility suits workers who value autonomy over security. Critics counter that "flexibility" is often a euphemism for risk transferred from firm to individual — the worker, not the company, now absorbs the cost of a slow week, an illness, or old age.`,
    question: "According to the passage, what do critics of gig work primarily object to?",
    options: [
      "A. The number of apps a single worker can use",
      "B. The transfer of financial risk from companies to workers",
      "C. The lack of a fixed schedule",
      "D. The absence of a single employer"
    ],
    answer: "B"
  },
  {
    id: 2,
    type: "mcq",
    passageId: "rc1",
    question: "The word 'unbundle' in the passage most nearly means:",
    options: [
      "A. To combine several things into one",
      "B. To separate previously combined elements",
      "C. To eliminate entirely",
      "D. To regulate strictly"
    ],
    answer: "B"
  },
  {
    id: 3,
    type: "mcq",
    passageId: "rc1",
    question: "Which of the following best captures the author's tone?",
    options: [
      "A. Uncritically enthusiastic about gig work",
      "B. Dismissive of both sides of the debate",
      "C. Analytical, presenting both perspectives without taking a side",
      "D. Strongly opposed to gig platforms"
    ],
    answer: "C"
  },

  // ── Standalone Verbal Ability (id 4-8) ──
  {
    id: 4,
    type: "mcq",
    question: "Choose the word closest in meaning to PARSIMONIOUS.",
    options: ["A. Generous", "B. Stingy", "C. Talkative", "D. Careless"],
    answer: "B"
  },
  {
    id: 5,
    type: "mcq",
    question:
      "The four sentences below, when properly sequenced, form a coherent paragraph. Choose the correct order.\n(1) As a result, several coastal cities have begun retrofitting infrastructure years ahead of schedule.\n(2) Sea-level projections for the next three decades have been revised upward twice in five years.\n(3) Each revision has cited faster-than-expected ice-sheet melt.\n(4) Climate scientists rarely agree on such short-notice changes to a decades-long model.",
    options: ["A. 2-3-1-4", "B. 4-2-3-1", "C. 2-4-3-1", "D. 1-2-3-4"],
    answer: "A"
  },
  {
    id: 6,
    type: "mcq",
    question: "Which sentence contains a grammatical error?",
    options: [
      "A. Neither of the proposals were accepted by the committee.",
      "B. She is one of the few managers who insists on daily reports.",
      "C. The data, along with the summary, was sent yesterday.",
      "D. Each of the applicants has submitted the required forms."
    ],
    answer: "A"
  },
  {
    id: 7,
    type: "tita",
    question:
      "Five words are given: STARE, RATES, TASER, TEARS, HEART. All are anagrams of each other except one. Type the ODD ONE OUT (in capital letters, exactly as given).",
    answer: "HEART"
  },
  {
    id: 8,
    type: "mcq",
    question:
      "The passage below is followed by a summary. Pick the summary that best captures the passage's central argument.\n\"Automation does not simply replace tasks; it reshapes the tasks that remain for humans, often making them more cognitively demanding rather than less.\"",
    options: [
      "A. Automation eliminates jobs entirely.",
      "B. Remaining human tasks after automation tend to become more, not less, mentally demanding.",
      "C. Automation makes all jobs easier.",
      "D. Cognitive work is unaffected by automation."
    ],
    answer: "B"
  },

  // ── RC Passage 2 (id 9-12) ──
  {
    id: 9,
    type: "mcq",
    passageId: "rc2",
    passage: `Behavioral economists have long noted that the way a choice is framed can matter more than the choice itself. Consider retirement savings: when employees must actively opt in to a pension scheme, participation rates hover around forty percent. When the default is reversed — enrollment is automatic, and workers must actively opt out — participation often exceeds eighty percent, even though the substantive choice on offer is identical. This asymmetry unsettles a foundational assumption of classical economics: that individuals, given complete information, will rationally select the outcome that maximizes their own welfare. If a mere change in default reshapes behavior so drastically, then the classical assumption of a stable, calculating rational agent looks less like a description of how people behave and more like a convenient fiction. Policy designers have seized on this insight, embedding defaults — sometimes called "nudges" — into contexts ranging from organ donation registries to cafeteria menus. Critics, however, warn that a government or employer skilled at setting defaults wields a quiet but considerable power over citizens' choices, one that operates below the threshold of conscious deliberation and therefore escapes the scrutiny that more overt forms of persuasion invite.`,
    question: "What does the passage suggest is the main implication of the opt-in/opt-out asymmetry?",
    options: [
      "A. Employees are generally opposed to saving for retirement",
      "B. The classical model of a rational, calculating agent may not accurately describe real behavior",
      "C. Cafeteria menus are the most effective place to apply nudges",
      "D. Organ donation rates are lower than pension participation rates"
    ],
    answer: "B"
  },
  {
    id: 10,
    type: "mcq",
    passageId: "rc2",
    question: "The word 'asymmetry' as used in the passage most nearly means:",
    options: [
      "A. Balance between two options",
      "B. A lack of correspondence between two things expected to match",
      "C. Similarity in outcome",
      "D. Random variation"
    ],
    answer: "B"
  },
  {
    id: 11,
    type: "mcq",
    passageId: "rc2",
    question: "Which of the following, if true, would most weaken the critics' concern described in the passage?",
    options: [
      "A. Governments rarely change default policies once set",
      "B. Most citizens, once informed of a default, can easily reverse it and often do so after reflection",
      "C. Cafeteria menus have little effect on eating habits",
      "D. Opt-out participation rates are higher than opt-in rates"
    ],
    answer: "B"
  },
  {
    id: 12,
    type: "mcq",
    passageId: "rc2",
    question: "The passage is best described as:",
    options: [
      "A. A technical explanation of statistical methods in economics",
      "B. An argument for banning nudges in public policy",
      "C. An exploration of a behavioral finding and its implications for both economic theory and policy ethics",
      "D. A historical account of pension reform"
    ],
    answer: "C"
  },

  // ── RC Passage 3 (id 13-16) ──
  {
    id: 13,
    type: "mcq",
    passageId: "rc3",
    passage: `Karl Popper proposed that what distinguishes a scientific theory from a non-scientific one is not that it can be verified, but that it can be falsified. A theory earns scientific status only if it forbids certain observations — if there exists some conceivable experiment or event that could, in principle, prove it wrong. Popper contrasted this with theories he considered pseudo-scientific, such as certain interpretations of psychoanalysis, which he argued could accommodate virtually any human behavior as confirming evidence, and therefore forbade nothing. A theory that explains everything, in Popper's view, explains nothing, because it takes no risk. This criterion reoriented the philosophy of science away from the older question of how theories are confirmed and toward the sharper question of how they might be refuted. Yet Popper's framework has itself been challenged. Historians of science have pointed out that working scientists rarely abandon a theory after a single disconfirming result; instead, they often preserve the core theory by modifying auxiliary assumptions, a practice Popper himself struggled to fully reconcile with his falsificationist ideal.`,
    question: "Which of the following best captures the main idea of the passage?",
    options: [
      "A. Popper argued science is defined by verifiability",
      "B. Popper argued scientific theories are distinguished by their vulnerability to being proven wrong, though this criterion faces practical challenges",
      "C. Psychoanalysis is a rigorous scientific discipline according to Popper",
      "D. Scientists always discard theories after one failed experiment"
    ],
    answer: "B"
  },
  {
    id: 14,
    type: "mcq",
    passageId: "rc3",
    question: "The word 'auxiliary' as used in the passage most nearly means:",
    options: [
      "A. Primary",
      "B. Supporting or secondary",
      "C. Contradictory",
      "D. Obsolete"
    ],
    answer: "B"
  },
  {
    id: 15,
    type: "mcq",
    passageId: "rc3",
    question: "Based on the passage, Popper would most likely categorize a theory that can explain any possible outcome as:",
    options: [
      "A. Highly scientific, because it fits all evidence",
      "B. Not genuinely scientific, because it takes no risk of being proven wrong",
      "C. Definitely true",
      "D. Impossible to state clearly"
    ],
    answer: "B"
  },
  {
    id: 16,
    type: "mcq",
    passageId: "rc3",
    question: "The final sentence of the passage primarily serves to:",
    options: [
      "A. Refute Popper's entire framework",
      "B. Introduce a limitation or complication to the theory just described",
      "C. Provide an example of falsification in practice",
      "D. Summarize the passage's main argument"
    ],
    answer: "B"
  },

  // ── RC Passage 4 (id 17-20) ──
  {
    id: 17,
    type: "mcq",
    passageId: "rc4",
    passage: `As cities have grown denser, the definition of public space has quietly narrowed. A plaza that once hosted markets, protests, and idle gathering is increasingly designed, monitored, and in some cases owned by private developers who grant public access under conditions they alone set — no loitering, no unpermitted assembly, hours of operation dictated by commercial tenants rather than civic need. Urban planners defend such spaces as pragmatic solutions in cities where municipal budgets cannot fund upkeep alone. Yet the trade-off is rarely made explicit to the public that uses these spaces daily, many of whom assume a plaza is a plaza, indifferent to who signs the maintenance contract. The distinction matters most in moments of dissent, when a privately governed square can restrict assembly in ways a genuinely public one, bound by constitutional protections, cannot.`,
    question: "Which of the following best states the main point of the passage?",
    options: [
      "A. Private developers should be banned from urban planning",
      "B. Municipal budgets are the primary cause of urban decay",
      "C. Privately managed public-seeming spaces carry different rules and protections than truly public ones, a distinction often invisible to ordinary users",
      "D. Protests are becoming less common in modern cities"
    ],
    answer: "C"
  },
  {
    id: 18,
    type: "mcq",
    passageId: "rc4",
    question: "What can be inferred about the author's view of the 'pragmatic solutions' cited by urban planners?",
    options: [
      "A. The author fully endorses them without reservation",
      "B. The author acknowledges the practical justification but points to an under-examined cost",
      "C. The author considers them irrelevant to the topic",
      "D. The author believes they have no effect on assembly rights"
    ],
    answer: "B"
  },
  {
    id: 19,
    type: "mcq",
    passageId: "rc4",
    question: "The word 'indifferent' as used in the passage most nearly means:",
    options: [
      "A. Hostile",
      "B. Unaware of or unconcerned with a distinction",
      "C. Extremely interested",
      "D. Legally bound"
    ],
    answer: "B"
  },
  {
    id: 20,
    type: "mcq",
    passageId: "rc4",
    question: "Which of the following best describes the tone of the passage?",
    options: [
      "A. Alarmist and exaggerated",
      "B. Measured but pointed, highlighting an overlooked consequence",
      "C. Purely celebratory of privatized public spaces",
      "D. Neutral to the point of having no argument"
    ],
    answer: "B"
  },

  // ── Standalone Verbal Ability (id 21-24) ──
  {
    id: 21,
    type: "mcq",
    question:
      "The four sentences below, when properly sequenced, form a coherent paragraph. Choose the correct order.\n(1) Yet within a decade, the same institutions were among the loudest advocates for reform.\n(2) In the early 2000s, most central banks dismissed the idea of publishing interest-rate forecasts as reckless transparency.\n(3) The shift was driven less by ideology than by evidence that clearer communication reduced market volatility.\n(4) Central bank communication has therefore evolved from deliberate opacity to calculated openness.",
    options: ["A. 2-1-3-4", "B. 4-2-1-3", "C. 2-3-1-4", "D. 1-2-3-4"],
    answer: "A"
  },
  {
    id: 22,
    type: "tita",
    question:
      "Five sentences are given below, numbered 1-5. Four of them form a coherent paragraph when properly sequenced; one does not belong. Type only the number of the sentence that does NOT belong.\n1. The printing press did not merely spread existing ideas faster; it changed which ideas could survive at all.\n2. Manuscripts, copied by hand, favored texts that a small circle of scribes and patrons deemed worth the labor.\n3. Gutenberg's press was developed in the German city of Mainz around 1440.\n4. Mechanical reproduction removed that bottleneck, allowing unconventional and even heretical texts to circulate widely.\n5. The result was not just more information, but a different selection of which information persisted.",
    answer: "3"
  },
  {
    id: 23,
    type: "mcq",
    question:
      "The paragraph below is followed by four options to complete it. Choose the option that completes the paragraph most logically.\n\"Museums have traditionally organized their collections by chronology or geography, guiding visitors through a fixed narrative of art history. A growing number of curators now favor thematic arrangements instead, placing a medieval altarpiece beside a contemporary installation if both explore, say, grief or transformation. Defenders argue this approach reveals connections a strict timeline would obscure. Critics counter that ______\"",
    options: [
      "A. thematic arrangement requires more gallery space than chronological displays",
      "B. stripping works of their historical context risks flattening the very differences that make them meaningful",
      "C. museums should be free to enter for all visitors",
      "D. contemporary art is inherently less valuable than historical art"
    ],
    answer: "B"
  },
  {
    id: 24,
    type: "mcq",
    question:
      "The passage below is followed by four summaries. Choose the one that best captures the passage's central argument.\n\"A city's skyline is often read as a straightforward record of its wealth — the taller the towers, the richer the metropolis. But height is as much a signal as a fact: developers build upward partly to project ambition to investors, regardless of whether local demand justifies the space. The result, in more than one boom-era city, has been a skyline of half-occupied towers, monuments to expectation rather than need.\"",
    options: [
      "A. Tall buildings always indicate genuine economic prosperity",
      "B. Skyscraper height can reflect speculative signaling as much as actual demand, sometimes producing underused towers",
      "C. Developers should be banned from constructing tall buildings",
      "D. Wealthy cities never build unnecessary skyscrapers"
    ],
    answer: "B"
  }
];

export default catVarc;